export default __webpack_public_path__ + "static/media/3.69ae9e0d.jpg";